class App {
    constructor(){
        this.lenis = null
    }
}

const store = new App;

export default store;